export default __webpack_public_path__ + "static/media/2019.e0164c77.png";